<template>
	<v-container>
		<template>		   
		    <alert 
		    	key					= "alert_modal"
		    	:info_to_component  = "item_alert"
		    	:info_to_category	= "render_categories_access"
		    	:type 				= "type_alert"
				:is_soundd 			= "is_sound"
				:number_alerts      = "data_alert && data_alert.length >= 0 ? data_alert.length : 0"
				ref_to_component  	= "'alerts'"
		    	@close				= "close_modal($event)"
		    	@render_type		= "render_type_alert($event)"		 
		    	:show_devices 		= "true"   	
		    />
	 	</template>	 
	 	<NotificationTechnical></NotificationTechnical>
	</v-container>
</template>
<script>
	import EventBus 	from '@/event-bus';
	import alert 		from '@/components/info/alert.vue';
	import axios 		from 'axios';
	import io 			from 'socket.io-client';
	import list_dev 	from '@/components/tester/jsons/list_devices_test.json'
	import alert_modal 	from '@/components/info/alert_modal.vue';
	import alertTestSocket from "@/components/info/test/alertTestSocket.js"
	import technicalService from "@/services/technicalService.js";
	import technicalFormat from "@/helpers/class/technicalFormat.js"
	import NotificationTechnical from "@/components/info/NotificationTechnicals.vue"
	// import format 		from '@/class/formats'
	// import test_lpr 	from  '@/components/tester/jsons/test_lpr_alerts.json'
	// import show_data_alertgun from '@/components/safe_zone/show_data.vue' 
	// import event_test from '@/components/tester/jsons/test_event_motion.json'
	// import test_lpr               from "@/components/tester/jsons/lpr_sep_28"
	// import test_face  	 	from '@/components/tester/jsons/tests_face.json'
	export default{
		name: 'connections',
		components:{
			alert, 
			NotificationTechnical,
			// show_data_alertgun
		},
		props:[
			'cloud',
			'devices',
		],
		// component:{ EventBus},
		data:() =>({
			message 			 : 'alert',
			alert_type 			 : '',
			alert_mode 			 : '',
			manual 				 : false,
			list 				 : [],
			options 			 : {},
		    list_clouds 		 : [],
		    total 			 	 : 0,
		    item_alert 		 	 : null,
			data_alert 			 : [],
			MAX_DATA_ALERT 		 : 100, // Límite máximo de alertas en memoria
			is_open_modal 		 : false,
			all_list 			 : [],
			all_list_hosts 		 : [],
			total_hosts 		 : 0,
			is_sound 			 : null,
			is_blacklist 		 : false,
			socket 				 : {},
			socket_sz 			 : null,
			item_alertgun 		 : null,
			socket_alert_support : null,
			connection : {
				socket 	: true,
				ws 		: false,
			},
			socket_ws 			: null,
			is_modal_alert 		: false,
			list_connections 	: {},
			list_devices 		: 	[],
			list_category 		: 	[],			
			type_alert 			: 'alert', // 'alert' || 'snack'
			sound 				: true,
			close_interval 		: null,
			list_access_rules   : [],
			timer_stream  		: null,		
			status_container_analytic    : {},	
			status_recording  	: {},
			status_analytics  	: {},
			is_constellation 	: false,
			list_constellation  : [],
			check_streaming		: false,
			timer_res_rtsp 		: null,
			setting_support  	: {},
			settings 			: {
				lpr: {
					formated : false,
				}
			},
			list_devices_online : [],
			list_channels 		: {},
			list_status_technicals : {},
		}), // data
		

		created(){
			// create formats
			
			
			this.$Format.update_list('ml', this.$ml);

			// get lists
			// this.get_list_category();
			// this.get_list_cloud();

			if (this.$settings_support) {
				this.setting_support = this.$settings_support;				
			}
		
				
		}, // created
		computed:{
			currentUser() {
				return this.$store.state.auth.user;
	  		//console.log(this.$store.state.auth.user.username);

	  		}, // currentUser

	  		render_categories_access(){
	  			let list 	= [],
	  				list1   = [];
	  			if (this.list_category && this.list_category.length > 0) {
	  				/*if (list & list.length > 0) {	  					
	  					list =  list.concat(this.list_category);
	  					
	  				}else{*/
	  					list = this.list_category;
	  				// }
	  			}
	  			if (this.list_access_rules && this.list_access_rules.length > 0) {
	  				/*if (list1 & list1.length > 0) {
	  					list1 = list1.concat(this.list_access_rules);
	  				}else{*/
	  					list1 = this.list_access_rules;
	  				// }

	  			}
	  			list = list.concat(list1);
	  			// console.log("render Lista categories", list) 
	  			return list;
	  		}, // render_categories_access

		},
		methods:{
			clearNewDeviceRtspTimer(){
				if (this.timer_res_rtsp) {
					clearTimeout(this.timer_res_rtsp);
					this.timer_res_rtsp = null;
				}
			},

			extractBackendErrorMessage(payload){
				if (!payload) {
					return '';
				}

				if (typeof payload === 'string') {
					return payload;
				}

				const directMessage = payload.message || payload.msg || payload.detail || payload.reason || payload.description;
				if (directMessage) {
					return String(directMessage);
				}

				if (payload.error) {
					return this.extractBackendErrorMessage(payload.error);
				}

				if (payload.data) {
					return this.extractBackendErrorMessage(payload.data);
				}

				return '';
			},

			renderNewDeviceRtspErrorMessage(payload, rtsp){
				const backendMessage = this.extractBackendErrorMessage(payload);
				const code = payload && (payload.code || payload.statusCode || payload.status) ? ` (${payload.code || payload.statusCode || payload.status})` : '';
				const baseMessage = backendMessage
					? `RTSP test failed${code}: ${backendMessage}`
					: 'RTSP test failed: camera did not respond within 8 seconds. Verify IP/port, credentials, network reachability and that the camera is online.';

				return rtsp ? `${baseMessage} RTSP: ${rtsp}` : baseMessage;
			},

			handleNewDeviceRtspTestFailure(payload, rtsp){
				this.clearNewDeviceRtspTimer();
				this.check_streaming = false;

				EventBus.$emit('notifications_modal',{
					type: 'connection',
					message: this.renderNewDeviceRtspErrorMessage(payload, rtsp)
				});

				this.$EventBus.$emit('res_new_device', false);
			},

			close_modal(item){
				this.item_alert    = null;
				this.is_open_modal = false;
			}, // close modal
			
			list_alert(){
				axios.get('endpoint',{

				}).then(function (response){
					this.list = response.data;
				}).catch(function (error){
					this.list = error;
				})
			},
			new_alert(){
				let alm, alt, pl, ml;
				for (let item of this.list){
					alm=item.alert_mb;
					alt=item.type;
					pl=item.plate;
				}

				if (!alm) { ml = true }
					this.manual=ml;
					this.alert_mode=alm;
					this.alert_type=alt;
					this.message  =pl;
			}, // new alert

			render_type_alert(item){
				// console.log("Render Type alert ", item)
				if (item.type == 'type'){
					this.type_alert = item.value;
				}else if (item.type == 'sound') {
					this.sound = item.value;
				}
			}, // render type

			render_alerts(item){
				// Limpiar el intervalo anterior si existe
				if (this.close_interval) {
					clearInterval(this.close_interval);
					this.close_interval = null;
				}
				const timer = setInterval(() => {    
					if (this.data_alert.length > 0) {
						if (!this.is_open_modal ) {
							let dato = this.data_alert.shift();
							if (this.is_blacklist) {
								// this.$emit('sync_alrts', false);
							}
							if (dato) {
								this.item_alert = dato;
								this.is_open_modal = true;
							}	
						}
					}
					if (this.data_alert.length === 0) {
						clearInterval(this.close_interval);
						this.close_interval = null;
					}
				}, this.data_alert.length == 1 ? 1000 : 2000);
				this.close_interval = timer;
			}, // render alerts

			get_list_cloud(){ 
		        let pg = 1, 
		        	sw = 0;
		        const api = this.$URL + '/api/v1/cloud/?page=' + pg; 
		        
		        this.$axios.get(api).then(response => {
			        let items = response.data.rows;	    	      		      
			        this.list_clouds = items;
			        if (items && items.length >0) {
			        	items.forEach((cloud)=>{
			        		if (cloud && cloud.type_integrate == 'cloud') {
			        			if (cloud.manager_id) {

			        			this.start_connection_ws("ws://" + cloud.ip_address + "/ws/events/" + (cloud.manager_id).replace(/\-/g,"") + "/", 'cloud ' + cloud.ip_address, 'lpr');
			        			}else{
			        				console.log("Manager id not found : ", cloud.manager_id);
			        			}
			        		}
			        	})
			        }else{
			        	if (this.$Debug && this.$Debug.logs) {
			        		console.log("No found rows cloud to connect")
			        	}
			        }
		        }).catch( error => {
		        	console.log("Error get cloud : ", error);
		        }) // axios
		      }, //get list

		      

			render_setting_sound(){			
				// console.log('charge settings sound');
				if (!localStorage.getItem('alert_sounds_setting')) {
					let pg    = 1;				
					const api = this.$URL+'/api/v1/category/?page='+ pg;
					
					this.$axios.get(api).then( res => {
						let item =res.data;
						let items=item.rows;								
						let list_sounds = JSON.stringify(items);
						localStorage.setItem('alert_sounds_setting', list_sounds);
						
						
					}).catch( er =>{
						console.log(er, 'error get list category')
					})
				
				}// if
			}, // render setting sound

			

			get_list_category(){
				const api = this.$URL + '/api/v1/category';
				this.$axios.get(api).then( res => {
					this.list_category = res.data.rows;
					// this.get_list_access_rules();
				
				}).catch(er => {
					console.log(" Error get category ", er);
					if (localStorage.getItem('categories')) {
						this.list_category = JSON.parse(localStorage.getItem('categories'));
					}
				})
			}, // get list category

			get_list_access_rules(){
				const api = this.$URL_face + '/api/face/ruleaccess';
				this.$axios.get(api).then( res => {
					this.list_access_rules = res.data.results;
				}).catch(er => {
					console.log(" Error get access rules ", er);
					
				})
			}, // get list category

			
			render_device(val){
				if (this.list_devices && this.list_devices.length > 0) {
					let vm 	   = this,
						device = ''	;

					const find = vm.list_devices.some( function (dev, idx_dev){
						if (dev.deviceId == val) {
							device = dev.name;
							return true
						}
					}) 

					return device;
				}
				return '';
			}, // render_device

			start_connection_ws(endpoint, name, analytic, count){
				// console.log("open connection WS ", endpoint);

				let vm = this;
				let ev = this;

				let status_msg_ws = this.$ml.get('data_no_found'), 
					color_msg_ws  = '';
				
				color_msg_ws 	= 'warning';
				
				try{
					// const socket = new WebSocket('ws://103.9.88.243/ws/events/33f2bd0e2e78466f95fcaa6e23eae856/');
					// list_sockets.push('ws://'+i.ip_address+'/ws/events/'+(i.manager_id).replace(/\-/g,"")+'/');
					const socket = new  WebSocket(endpoint);
						// const socket = new WebSocket("ws://"+endpoint+".cloud.alicesecurity.co" + "/ws/events/"+ endpoint+"/");
						socket.onmessage = function (e) {
							//console.log( e, 'message')
							let msg 	= JSON.parse(e.data);
							if (msg && msg.type && ['sync_blacklist', 'sync_save', 'sync_delete'].includes(msg.type)) {
								EventBus.$emit('notifications_modal',{
		     						type 	: 'success',
		     						message : vm.$ml.get('sync_cloud'),
		     					})
							}else{


								
								let info 	= vm.$Format.format_info(msg, analytic, 'alert',true);

									// console.log("info WS ", info);
								if (info && info.formated) {
									//info.formated.is_ws=true
									if (info.formated.alert && info.formated.alert.isPopup) {											
										if (vm.data_alert.length === 0) {
						     				vm.render_alerts();
						     			}
						     			// console.log("length Array alerts  face: ", vm.data_alert.length);
						     			
						     			// console.log("info Event alert : ", true);
						     			
						     			// Limitar tamaño de data_alert - eliminar los más antiguos si excede el límite
						     			if (vm.data_alert.length >= vm.MAX_DATA_ALERT) {
						     				vm.data_alert.shift(); // Eliminar el más antiguo
						     			}
						     			vm.data_alert.push(info.formated);
									}

				     				if (analytic == 'face') { // ALARMS
										// EventBus.$emit('events_alerts', info); // alert face
				     				}else{ // face
				     					// lpr

										//EventBus.$emit('events_alerts', info); // alert face

				     				} // lpr
				     			
								}

								// EventBus.$emit('events_alerts', info); // cloud
								if (analytic == 'face') {
									if (!msg.device) {
										if (msg && msg.host_id) {
											let temp_dev = vm.$Format.render_device(msg.host_id);
											if (temp_dev) {
												msg.device 	= temp_dev.name;
											} 
										};
									}
									// EventBus.$emit('events_face', msg);
								}
								//ev.render_setting_sound(infos);
								
								// Liberar memoria después de procesar el mensaje
								msg = null;
								info = null;
							}
						}
						socket.onopen = function (is_on){
							

								status_msg_ws = vm.$ml.get('connected');
								color_msg_ws  = 'success';
								EventBus.$emit('status_ws', { status_msg_ws, color_msg_ws });
								// vm.$emit('active_alerts',{ name: 'ws_cloud',status_msg_ws, color_msg_ws } );
								// console.log(is_on, 'is connected ws')
							
						}

						socket.onerror = function(evt) {
							status_msg_ws = vm.$ml.get('disconnected');
							color_msg_ws  = 'error';
							EventBus.$emit('status_ws', { status_msg_ws, color_msg_ws });
							socket.close();
							// console.log(evt, 'event error')
						};
						socket.onclose = function(evt){
							let msg = vm.$ml.get('reconnecting_ws');//+': '+ i.ip_address;
							// console.log("onclose ws : ", msg);
							status_msg_ws = msg;
							color_msg_ws  = 'primary';
							EventBus.$emit('status_ws', { status_msg_ws, color_msg_ws });
							const timer = setTimeout(function() {
								if (count < 15) {
						      		vm.start_connection_ws(endpoint, name, analytic, count);
								}else{
									console.log("limit reconnecting reached, connection : ", endpoint + ' ', name);
								}
								clearTimeout(timer);
						    }, 30000);
						}
				}catch (e) {
					console.log(e, 'error ws')
				}
				
				// Liberar variables locales después de configurar la conexión
				vm = null;
				ev = null;
				status_msg_ws = null;
				color_msg_ws = null;
			}, // start connection ws


			connect_socket(localhost, port, workspace = 'workspace', name, info, info1){
				
				let vm 				= this;
				let ev 				= this;
				let count_reconnect = 0;
				let sum_reconect 	= 100;

				const namespace = name && workspace ? workspace+'-'+name : workspace;
				if (this.$Debug && this.$Debug.logs) {
					console.log("space : " ,namespace , port, localhost)
				}

				
				const socketCounting = io(ev.$protocol_socket + localhost + ':' + port + '/' + namespace, ev.$setting_socket);
				
					// jcae.guardian.alicesecurity.co
					// path: '/ws',
				
      			socketCounting.emit("start_streaming", name);

				let info_connects = info == 'connection_rtsp' ? 'test_' + info1 : info ? info : name;
				if (this.$Debug && this.$Debug.logs) {
					console.log("NAME CONNECTION :  name space : ", name, ' info connect : ', info_connects);
				}
				let nm_connection = name;
				// For close socket					
				ev.socket[nm_connection]			=	socketCounting;		
				ev.list_connections[nm_connection]	= 	{ 
					name 	: info_connects,
					status 	: ev.$ml.get('connecting'),
					color 	: 'info'
				};	
				EventBus.$emit('status_connections', ev.list_connections[nm_connection]);
				
				// console.log(socketCounting,'socket blacklist')
				// for installation
				/*socketCounting.on('event', function (message) {
					let mssg = message;
					EventBus.$emit('start',mssg);

				})*/

				let status_msg_bl = '', 
					color_msg_bl  = '';

				if (info == 'connection_rtsp') {
					// send rtsp
					if (this.$Debug && this.$Debug.logs) {
						console.log(localhost, port, name, info, "******************** INFO TO RTSP")
					}
      				socketCounting.emit("test_rstp", { 
      					rtsp 		: name,
      					deviceId 	: info1,
      				});
					
					// EventBus.$emit("connection_new_device", info);
					
					// for new device
					// EventBus.$emit('res_new_device', mssg);
				}


				/* ********************** Sending Events objects  **********************************+*/
		     	socketCounting.on('event', (message)=> {
		     		
		     		let mssg = message;
		     		// console.log(mssg.hostId , " == ", info," ************* message ch event" , message);
		     		
		     		// for start class
		     		EventBus.$emit('start'+ mssg.hostId, mssg);
		     		
		     		// for events
		     		// EventBus.$emit('events', mssg);
		     		if (mssg.source == 'action') {
		     			// console.log("actions ", message);
						this.$store.commit("Counter/renderCount", {...message, typeCount : "action"});		     		
		     			EventBus.$emit('events_action', message);
		     		}else
		     		if (mssg.source == 'tracker') {
		     			// console.log("objects ", message)
						this.$store.commit("Counter/renderCount", {...message, typeCount : "objects"});		     		
		     			EventBus.$emit('events_object', message);

		     		}

		     		// logs install-image
		     		
		     		
		     		
		     		// console.log('event ... ', message , mssg.source, mssg.analytics_results[0].tag)

		     		
		     		if (vm.is_constellation && vm.list_constellation && vm.list_constellation.length > 0) {
		     			let search = mssg.hostId;
		     		
		     			const find  = vm.list_constellation.some( function( arr_const, idx_const){
		     				if (arr_const.device == search && arr_const.state) {
		     					// console.log('send Constellation: ',search)
		     					EventBus.$emit('event_constellation'+arr_const.id, mssg);
		     					return true
		     				}
		     			})
		     				
		     		}

		     		// Liberar memoria después de procesar el evento
		     		mssg = null;
		     		message = null;
		     		
		     	});

		     	socketCounting.on('action', function(message) {
		     		EventBus.$emit('event_action', message);
		     		
		     	
		     	});// events action

		     	socketCounting.on('event_gps', function(message) {
		     		EventBus.$emit('event_gps', message);
		     		
		     	}); // event gps

		     	socketCounting.on('event_installations', function(message) {
		     		// console.log("Installation : ", message);
		     		let mssg = message;
			     	if (info == 'install-image') {

		     			EventBus.$emit('event_progress_image', mssg);	
		     		}
		     		/*if (info == 'install-device') {
		     			EventBus.$emit('event_progress', mssg);
		     		}*/
			    }); // event installation

		     	socketCounting.on('stream', function(message) {
		     		let mssg = message;		
		     		// console.log('streaming ... ')	  
		     		vm.timer_stream = new Date();
		     		EventBus.$emit('stream' + name, mssg);
		     		
		     		// Liberar memoria después de procesar el stream
		     		mssg = null;
		     		message = null;
		     	})
		     	socketCounting.on('stream_lpr', function(message) {
		     		let mssg = message;
		     		// console.log('streaming lpr... ')	     		
		     		EventBus.$emit('stream' + name, mssg);
		     		
		     		// Liberar memoria después de procesar el stream LPR
		     		mssg = null;
		     		message = null;
		     	})
		     	
		     	vm.status_recording[name] = false; 

		     	socketCounting.on('recording', function(message){		     		
		     		// console.log("recording **************", name, message);
		     		
		     		let state = message ? true : false;
		     		if (state != vm.status_recording[name]) {
		     			vm.status_recording[name] = state ;
		     			EventBus.$emit('recording' + name, state);
		     		}
		     	});
		     	
		     	/*if (!sw_test) {
		     		sw_test = true
			     	let test = false;
			     	setInterval(()=>{
			     		console.log("TEST recording : ", test);
			     		EventBus.$emit('recording' + '42c26667-04b5-4d38-b2d7-a77ae859afd5', test);
			     		test = !test;
			     	}, 15000)
		     	}*/
		     	// socketCounting.on('data_counter', (message)=> {
		     		// console.log("DATA COUNTER ", message)
		     		// EventBus.$emit("events_data_counter", {...message});
		     	// });

		     	// Buffer y timer para eventos LPR
		     	let lprBuffer = [];
		     	let lprBufferTimer = null;

		     	socketCounting.on('lpr', (message)=> {
		     		if (message) {
		     			lprBuffer.push(message);
		     			if (!lprBufferTimer) {
		     				lprBufferTimer = setTimeout(() => {
		     					let bufferCopy = lprBuffer.slice();
		     					lprBuffer = [];
		     					lprBufferTimer = null;
		     					bufferCopy.forEach((msg) => {
		     						this.$store.commit("Counter/renderCount", { ...msg, typeCount: "lpr" });
		     						msg.is_ref = 'lpr';
		     						let info = vm.$Format.format_info({ ...msg }, "lpr");
		     						if (info) {
		     							EventBus.$emit('events_lpr', { ...info });
		     						}
		     						// Liberar memoria después de procesar cada mensaje
		     						msg = null;
		     						info = null;
		     					});
		     					// Liberar buffer después de procesar
		     					bufferCopy = null;
		     				}, 100); // Procesa cada 100 ms
		     			}
		     		}
		     		// Liberar mensaje después de procesar
		     		message = null;
		     	})

		     	socketCounting.on('register_event_parking', function(message) {
		     		let mssg 	= message;
		     		if (mssg) {		     			
			     		mssg.is_ref = 'parking';
			     		// console.log('events ch lpr... ', message)	     		
			     		EventBus.$emit('events_parking', mssg);
		     		}
		     	})
				
				socketCounting.on('counter', function(message) {
		     		let mssg 	= message;
		     		if (mssg) {		     			
			     		mssg.is_ref = 'counter';
			     		console.log('events ch counter... ', message)	     		
			     		EventBus.$emit('events_counter', mssg);
		     		}
		     	})
		     	// let list_detected = []
		     	socketCounting.on('face', function(message) {
		     		if (message) {
		     				// list_detected.push(message);
		     			if (message.to == "face") {
							//console.log("FACE  ********************************* ",  message.tracker_id,message.state);
				     		let info = vm.$Format.format_info({...message}, "face_detected");
				     		if (info && (message.state==0 || message.state==1) ) {
								EventBus.$emit('events_face', { ...info });
				     		}
		     			}else{

		     				if (message.to) {
		     					// console.warn("FACE to  ********************************* ", namespace , message.to , " == ", "face_cropping" + message.tracker_id, message);
								EventBus.$emit(message.to, message);
		     				}

		     			}		     			
		     		}


		     	});

		     	socketCounting.on("face_recognized", function(message){
		     		let info = vm.$Format.format_info({...message}, "face_recognized");
		     		if (info) {
						EventBus.$emit('events_face_recognized', { ...info });
		     		}
		     	});

		     	socketCounting.on('videodb', (message)=> {
		     		this.$EventBus.$emit("load_videodb",message);
		     	});


		     	vm.status_container_analytic[name] = {};
		     	let state 	= {};
		     	let sw_init = {};
		     	socketCounting.on('status_container', function(message) {
		     		if (message) {
		     			const temp_container =  message.Id;
			     		// console.log(temp_container, state[temp_container], vm.status_container_analytic[name][temp_container], message.State.Running)
			     		if (message && (message.State.Running || !message.State.Running) ) {
			     			if (vm.status_container_analytic[name][temp_container] ||  !vm.status_container_analytic[name][temp_container]){
			     				if (!sw_init[temp_container]) {
			     					sw_init[temp_container] = true;
			     					vm.status_container_analytic[name][temp_container] = !message.State.Running;
			     				}
			     				
			     				state[temp_container] = message.State.Running;
			     			}
			     		}
			     		// console.log("status_container_analytic ", state )
			     		if (state[temp_container] != vm.status_container_analytic[name][temp_container]) {
			     			vm.status_container_analytic[name][temp_container] = state[temp_container];('status_container', message);
				     		EventBus.$emit('status_container', message); // for analytics	
				     		EventBus.$emit('status_container' + name , { 
				     			idContainer : temp_container,
				     			state 		: state[temp_container]
				     		}); // for cam
			     		}
		     		}
		     		// if (vm.$route.name == 'setting_device') {		
		     		// }
		     	});

		     	// draw bbox stream
		     	socketCounting.on('draw_streaming', function(message) {		     		
		     		// for cam
		     		// console.log("draw_streaming : ", message)
		     		if (message) {		     			
			     		let devId = message.hostId || message.host_id; 
			     		EventBus.$emit('event_stream' + devId, {...message});
		     		}
		     	});
		     	socketCounting.on('counter_history_smart_event', (message)=> {
					vm.$store.commit("Counter/renderHistoryCount", message ); // { deviceId : message.deviceId, count: # -  0, total: #, ruleId :  integer, (timestamp || unix_itme_stamp)}
		     	});
		     	
		     	socketCounting.on('states_workspace', function(msg) {
		     		// console.log("states_workspace", msg);
		     		// EventBus.$emit("states_workspace", {...msg});
		     		vm.$store.dispatch('Workspaces/add_to_workspaces', {...msg});
		     	});
		     	// ***************************************************************************************** ALERT ******

		     	let sw_alert = true;			     	
		     	socketCounting.on('alert', (mssg)=> {
		     		if (sw_alert){
		     			sw_alert = false;
		     			console.log(mssg, "******************************* MSG TRACKER Alert")
		     		}
		     		// console.log(mssg, "******************************* MSG Alert 1", JSON.stringify(mssg))
		     			// console.log("alert **************************************: ", mssg)

		     		let info = null;
		     		/*if (mssg.analytic == 'actions') {
		     			console.log("actions **************************************: ", mssg)
		     			info = mssg;
		     		}*/

		     		// console.log("Alert draw " , mssg)
		     		if (mssg.analytic == 'lpr') {		     			
		     			info = vm.format_event_lpr(mssg);
		     			if (info && info.deviceId) { // for alert in zone
		     				//console.log('Emit Alert LPR', info);
		     				EventBus.$emit('Alert' + info.deviceId, info ? info : mssg );
		     			}
		     		}
		     		else{
		     			// console.log("OBEJCT ALERT : ", mssg)
		     			info = vm.$Format.format_info(mssg, 'alarms', 'alert',true);
		     			if (info && info.deviceId) { // for alert in zone
		     				//console.log('Emit Alert ALARM', info);
		     				EventBus.$emit('Alert' + info.deviceId, info ? info : mssg );
		     			}
		     		}

		     		if (info && info.formated) {
		     			if (vm.data_alert.length === 0) {
		     				//console.log('Llamando a render_alerts');
		     				vm.render_alerts();
		     			}
		     			//console.log('Agregando a data_alert:', info.formated);
		     			vm.data_alert.push(info.formated);
		     		}
		     		info.original_source = { ...mssg };
					this.$store.commit("Counter/renderCount", {...mssg, typeCount : "alerts"});		     		
		     		//console.log('EventBus.$emit events_alerts', info ? info : mssg);
		     		EventBus.$emit('events_alerts', info ? info : mssg ); // mssg
		     		
		     		// Liberar memoria después de procesar la alerta
		     		info = null;
		     		mssg = null;
		     	});
		     	
		     	socketCounting.on('alert_map', function(mssg) {		     		
		     		if (mssg && mssg.deviceId) {		     			
			     		let info = vm.$Format.render_device(mssg.deviceId);
			     		// console.log("alarms EVENT DEVICE ALERT ", info)
			     		if (info) {
			     			EventBus.$emit('events_alerts_map', { ...info }); // mssg
			     		}
		     		}
		     	}); 

		     	socketCounting.on('smart_event', (mssg)=> {
		     		// console.log("smart event ", mssg);
					this.$store.commit("Counter/renderCount", {...mssg, typeCount : "smart_event"});		     		
		     		if (mssg.analytic == 'lpr') {
		     			let info = vm.format_event_lpr(mssg); //mssg && mssg.table ? mssg.table : mssg;
			     		EventBus.$emit('events_smart_event', {...info, ruleId : mssg?.ruleId});
		     		}else{
		     			// console.log("Check event ", mssg)
			     		let info = vm.$Format.format_info(mssg, 'smart_event');
			     		if (info) {
			     			EventBus.$emit('events_smart_event', {...info});
			     		}
		     		}
		     	})
		     	socketCounting.on('parking_statistics', function(mssg) {
		     		// console.log("smart event ", mssg);		     		
		     		if (mssg) {
		     			EventBus.$emit('events_parking_counter', mssg);
		     		}
		     	});

		     	// Listener para operationsession - cuando se envía /api/v1/operationsession
		     	socketCounting.on('operationsession', function(mssg) {
		     		// console.log('📊 [OPERATIONSESSION] WebSocket recibido:', mssg);
		     		if (mssg) {
		     			// Emitir al EventBus para que llegue al componente counter
		     			EventBus.$emit('events_counter', mssg);
		     			
		     			// También actualizar el store si es necesario
		     			vm.$store.commit("Counter/renderCount", {...mssg, typeCount: "counter"});
		     		}
		     	});

		     	socketCounting.on("avc", (mssg)=> {
		     		let info = vm.$Format.format_info(mssg, "avc");
					this.$store.commit("Counter/renderCount", {...mssg, typeCount : "avc"});		     		
		     		if (info) {
		     			EventBus.$emit("events_avc", { ...info });
		     		}
		     	})
		     	

		     	socketCounting.on('test_streaming', function(message) {
		     		let mssg = message;
		     		/*
						{
							channel  : 'basic',
							deviceId : '',
							message  : base64data
						}
		     		*/
		     		// console.log("TEST STREAMING : ", message)
		     		if (mssg) {
		     			// cancel res
							vm.clearNewDeviceRtspTimer();
		     			// cancel loading
		     			if (!vm.check_streaming) {
		     				EventBus.$emit('res_new_device', true);
		     				vm.check_streaming = true;
		     			}
		     			EventBus.$emit('stream' + mssg.deviceId , mssg); // 'new_device'

		     		}
		     	})

					const rtspTestErrorHandler = function(message) {
						if (info == 'connection_rtsp' && info1 == 'new_device') {
							vm.handleNewDeviceRtspTestFailure(message, name);
						}
					};
					socketCounting.on('test_streaming_error', rtspTestErrorHandler);
					socketCounting.on('rtsp_error', rtspTestErrorHandler);
					socketCounting.on('streaming_error', rtspTestErrorHandler);

		     	

		     	socketCounting.on('status', function(message) {
		     		// console.log(message, 'status');			     		
		     		let mssg = message;
		     		if (mssg && !vm.status_analytics[mssg.deviceId]) {
		     			vm.status_analytics[mssg.deviceId] = mssg;
		     			/*{
				     		motion : { analytics : false, cam : false },
				     		object : false,
				     		status_streaming : false,
				     		tracker : false
		     			};*/
		     		}
		     		if (mssg && vm.status_analytics && vm.status_analytics[mssg.deviceId]) {
			     		if (vm.status_analytics[mssg.deviceId].motion.statusAnalytics != mssg.motion.statusAnalytics ||
			     			vm.status_analytics[mssg.deviceId].motion.statusCam != mssg.motion.statusCam || 
			     			vm.status_analytics[mssg.deviceId].object.statusAnalytics != mssg.object.statusAnalytics ||
			     			vm.status_analytics[mssg.deviceId].statusStreaming != mssg.statusStreaming ||
			     			vm.status_analytics[mssg.deviceId].tracker.statusAnalytics != mssg.tracker.statusAnalytics) {
		     				// console.log("DIFF STATUS : ", vm.status_analytics[mssg.deviceId], mssg)

				     		EventBus.$emit('status_analytic' + mssg.deviceId, mssg);	
				     		vm.status_analytics[mssg.deviceId] = mssg;		     	
			     		}
				     	EventBus.$emit('status_analytic', mssg);
			     	}
		     	})

		     	socketCounting.on('confirmation_alert', (message)=> {
		     		// console.log("confirmation_alert ", message)
		     	})
		     	socketCounting.on('confirmation-smart-event', (message)=> {
		     		// console.log("confirmation ", message)
		     	})
		     	socketCounting.on('confirmation-notification', (message)=> {
		     		// console.log("confirmation notification ", message)
				    EventBus.$emit('confirmation-notification' + message);	

		     	})


		     	// ======================== STATUS SYSTEM ======================
		     	/*{
					error : null ,
					res   : null,
					msj   : '' , // mensaje para usuario
					code  : number
				}*/

				
				socketCounting.on('metadata', function(message){
					//aconsole.log(message,'metadata')
					EventBus.$emit('event_metadata',message )
				})

				socketCounting.on('relay_info', function(message){
					//console.log(message,'relay_info')
					EventBus.$emit('relay_info',message )
				})

				socketCounting.on('relay_io_state_history', function(message){
					EventBus.$emit('relay_io_state_history', message)
				})

		     	socketCounting.on('notifications_system', function(message){
		     		
		     		if (message){
		     			
		     			let info = vm.$Format.format_info(message, 'technical');
		     			if (info) {
		     				EventBus.$emit('events_technical', info);
		     				if (info.deviceId) {
		     					// console.log("Tecnicals ************************  	", info)
		     					vm.list_status_technicals[info.deviceId] = info; 	     		
								// EventBus.$emit("NotificationTechnicals", {...info});
		     							
		     				}		

		     				// console.log("state technical ", info.module, info.state, info)	     					
		     				if (["ping", "retransmission"].includes(info.module) && info.deviceId) {
		     					// console.log("state technical 1 sending",)	     					

			     				EventBus.$emit('status_recording' + info.deviceId, info);
		     				}		     				
		     			}



		     		}
		     	});
		     	socketCounting.on("remote-notification", (message)=>{
		     		console.log("Channel remote-notification", message)
		     		if (message ) {
		     			const {type , text } = message; 
			     		EventBus.$emit("notifications_modal",{
			     			type,
			     			message : text,
			     		});
		     		}
		     	})

				socketCounting.on('space_device', function(message) {
			     	// console.log("space_device ", message)
		     					     		
		     		EventBus.$emit('space_devices', { ...message });			     		
		     	})		     	

		     	socketCounting.on('logs', function(message) {
		     	
		     		let mssg = message;			     		
		     		EventBus.$emit('log_events', mssg);			     		
		     	})

				

		     	socketCounting.on('event_motion', (message)=> {
		     		// console.log(message, 'event motion')
		     		EventBus.$emit('motion_event', message);	
		     		this.$store.commit("Counter/renderCount", {...message, typeCount : "motion"});		     		
		     		EventBus.$emit('motion_event' + name, message);			     		
		     	})

		     	socketCounting.on('entry_stream', function(message) {
		     		
		     		console.log(message, 'message socket channel entry_stream');
		     		
		     		
		     	})

		     	socketCounting.on("actionOnUser",(msg)=>{		     		
		     		if(msg){
		     			if (msg.action == "deleteUser") {
		     				ev.logoutUser(msg);
		     			}
		     		}
		     	}); // actionOnUser

		     	socketCounting.on('connect', () =>{
		     		// console.log(socketCounting.connected, 'connected socket');
		     		if (ev.list_connections && ev.list_connections[nm_connection] && ev.list_connections[nm_connection].name && ev.list_connections[nm_connection].color) {

			     		ev.list_connections[nm_connection].status 	=  ev.$ml.get('connected');
			     		ev.list_connections[nm_connection].color 	=  'success';
			     		EventBus.$emit('status_connections', ev.list_connections);
			     		
			     		EventBus.$emit('status_stream' + name, { 
			     			color 	: 'success',
			     			message : ev.$ml.get('connected')
			     		})
		     		}
		     	})
		     	socketCounting.on('reconnecting', (msg) =>{
		     		if (ev.list_connections && ev.list_connections[nm_connection] && ev.list_connections[nm_connection].name && ev.list_connections[nm_connection].color) {
			     		ev.list_connections[nm_connection].status 	=  ev.$ml.get('reconnecting');
			     		ev.list_connections[nm_connection].color 	=  'primary';
			     		EventBus.$emit('status_connections', ev.list_connections);
			     		
			     		EventBus.$emit('status_stream' + name, { 
			     			color 	: 'primary',
			     			message : ev.$ml.get('reconnecting')
			     		})
			     		// socketCounting.disconnect()
		     		}
		     	});
		     	socketCounting.on('disconnected', (msg)=> {
		     		if (ev.list_connections && ev.list_connections[nm_connection] && ev.list_connections[nm_connection].name && ev.list_connections[nm_connection].color) {
			     		ev.list_connections[nm_connection].status 	=  ev.$ml.get('disconnected');
			     		ev.list_connections[nm_connection].color 	=  'error';
			     		EventBus.$emit('status_connections', ev.list_connections);

			     		EventBus.$emit('status_stream' + name, { 
			     			color 	: 'error',
			     			message : ev.$ml.get('disconnected')
			     		})
			     	}


		     	});
		     	socketCounting.on("disconnect", (reason) => {
		     		if (ev.list_connections && ev.list_connections[nm_connection]) {
		     			ev.list_connections[nm_connection].status 	=  ev.$ml.get('disconnected');
			     		ev.list_connections[nm_connection].color 	=  'error';
		     			EventBus.$emit('status_connections', ev.list_connections);
				  		// console.log("socket disconnect 1: ", ev.list_connections[nm_connection].name, reason)
				  		/*const timer = setTimeout(()=>{
					  		if (ev.list_connections && ev.list_connections[nm_connection] && ev.socket[nm_connection]) {
					  			// vm.connect_socket(localhost, port, workspace, name, info, info1);
					  			ev.list_connections[nm_connection].status 	=  ev.$ml.get('reconnecting');
					     		ev.list_connections[nm_connection].color 	=  'primary';
					     		EventBus.$emit('status_connections', ev.list_connections);
					  			socketCounting.connect();
					  			console.log("reconnecting socket : ", nm_connection)
					  			// ev.list_connections[nm_connection].connect();
					  		}
					  		count_reconnect += sum_reconect;
					  		clearTimeout(timer)
				  		}, 5000 + count_reconnect)*/
		     		}
				});
				socketCounting.on("connect_error", (error) => {
					if (ev.list_connections && ev.list_connections && ev.list_connections[nm_connection]) {
				  		// console.log("Connect error socket and disconnect : ", ev.list_connections[nm_connection].name);
				  		// socketCounting.Disconnect()
				  		ev.list_connections[nm_connection].status 	=  ev.$ml.get('disconnected');
			     		ev.list_connections[nm_connection].color 	=  'error';
		     			EventBus.$emit('status_connections', ev.list_connections);
						if (info == 'connection_rtsp' && info1 == 'new_device') {
							vm.handleNewDeviceRtspTestFailure(error, name);
						}
				  		/*const timer = setTimeout(()=>{
				  			ev.list_connections[nm_connection].status 	=  ev.$ml.get('reconnecting');
					     	ev.list_connections[nm_connection].color 	=  'primary';
					     	EventBus.$emit('status_connections', ev.list_connections);
					  		socketCounting.connect();
					  		count_reconnect += sum_reconect;					  						  		
				  			clearTimeout(timer)
				  		}, 5000 + count_reconnect)*/	
				  	}
			     	

				});

		     	/*socketCounting.on('connect', (msg)=> {
	     		ev.$emit('is_connect_ws', true);
		     	})  /
				socketCounting.on('error', (error) => {
				  // ev.color_message='error';
				  console.log(error, 'error blacklist');
				});

				*/				
			}, //  connect socket

			open_channel(connection, channel, format){
				if (this.socket && this.socket[connection]) {
					this.socket[connection].on(channel, this.list_channels[channel] = (message) => {
						if (message) {
							this.$EventBus.$emit(channel, message);
						}
					})
				}
			}, // open channel

			close_channel(connection, channel){
				if (this.socket && this.socket[connection] && this.list_channels && this.list_channels[channel]) {
					this.socket[connection].off(channel, this.list_channels[channel]);
					this.list_channels[channel] = null;
					console.log("Channel closed ", channel, this.list_channels[channel]);
				}
			}, // close channel

			format_event_lpr(mssg){
				let vm = this;
				if (vm.settings && vm.settings.lpr && vm.settings.lpr.formated) {
     				return vm.$Format.format_info(mssg, 'lpr', 'alert');
     			}else{
     				if (mssg && mssg.table ) {
     					let datee = "";
     					let deviceName = "";
     					if (mssg.deviceId) {
     						const device = this.$Format.render_device(mssg.deviceId)
     						if(device){
     							deviceName = device.name;
     						}
     					}
     					mssg.table.device = deviceName;
     					if (mssg.table.tags_colors && mssg.table.tags_colors.length > 0) {
     						mssg.table.tags_colors.forEach((it)=>{
     							if (it) {
     								it.tag = this.$ml.get(it.tag) ?  this.$ml.get(it.tag) : it.tag;
     							}
     						})

     					}
     					if (mssg.table.date) {
     						mssg.table.date = vm.$Format.format_date(mssg.table.date);
     						datee = mssg.table.date
     					}

     					if (mssg.table && mssg.table.formated && mssg.table.formated.content) {
     						if (mssg.table.formated.content.date) {
     							mssg.table.formated.content.date = datee;
     						}
     						// console.log("TAG ", mssg.table.formated.content) // 
     						if (mssg.table.formated.content.tag) {
     							mssg.table.formated.content.tag = this.$ml.get(mssg.table.formated.content.tag)?this.$ml.get(mssg.table.formated.content.tag):mssg.table.formated.content.tag;
     						}else if(mssg.table.formated.content.tags){
     							mssg.table.formated.content.tag =this.$ml.get(mssg.table.formated.content.tags)?this.$ml.get(mssg.table.formated.content.tags):mssg.table.formated.content.tags;
     						}else{
     							mssg.table.formated.content.tag = mssg.table.formated.content.plate_chars
     						}
     						mssg.table.formated.content.device = deviceName;
     					}
     				}
     				return mssg && mssg.table ? mssg.table : mssg;

     			}
			}, // format_event_lpr

			async getStatusTechnicals(){
				try{
					const tecnical = new technicalService();
					const { data } = await tecnical.getList();
					
					if (data && data.states && data.states.devices) {
						for(let it in data.states.devices){							
							const info = new technicalFormat();
							info.setInfo(it, data.states.devices[it]);	
							this.list_status_technicals[it] = info.getInfoTechnical();		
							if (data.states.devices[it] && data.states.devices[it].retransmission_local) {				
								const tempInfo = {...data.states.devices[it].retransmission_local, name : data.states.devices[it].name, deviceId: it}; 				
								EventBus.$emit("NotificationTechnicals", tempInfo);
	     						EventBus.$emit('events_technical_menu_notifications', tempInfo);	
							}
			     			if (data.states.devices[it] && data.states.devices[it].rtsp) {								
								const tempInfo = {...data.states.devices[it].rtsp, name : data.states.devices[it].name, deviceId: it};
								EventBus.$emit("NotificationTechnicals", tempInfo);
	     						EventBus.$emit('events_technical_menu_notifications', tempInfo);	
							}

						}
					}
					
				}catch(er){
					console.warn("Error get getStatusTechnicals " , er)
				}
			}, // getStatusTechnicals

			logoutUser(item){
				if (item && item.userId) {					
					if (this.currentUser && this.currentUser.user && this.currentUser.user.id && this.currentUser.user.id == item.userId) {		
						EventBus.$emit("notifications_modal",{
							type : "warning",
							message : this.$ml.get("closing_session"),
							loading : true,
						})
						const timer = setTimeout(()=>{
							EventBus.$emit("notifications_modalapp", true);					
							clearTimeout(timer);
						},3500)
					}
				}
			},

			formatAlertTechnical(){
				let msj 	 	= '',
	 				type 		= '',
	 				persistent  = false,
	 				position    = 'top',
	 				temp_device = null;
	 			if (message.res) {
	 				type = 'success';
	 				if (message.res.deviceId) {
	 					let temp_name = vm.render_device(message.res.deviceId);
	 					temp_device = {
	 						deviceId : message.res.deviceId,
							    name 	 : temp_name,
							   };
	 				}
	 			}
	 			if (message.error) {
	 				type = 'error';
	 				if (message.error.deviceId && !temp_device) {
	 					let temp_name = vm.render_device(message.error.deviceId);
	 					temp_device = {
	 						deviceId : message.error.deviceId,
								name 	 : temp_name,
							};
	 				}

	 			}
	 			if (message.warn) {
	 				type = 'warning';
	 				if (message.warn.deviceId && !temp_device) {
	 					let temp_name = vm.render_device(message.warn.deviceId);
	 					temp_device = {
	 						deviceId : message.warn.deviceId,
								name 	 : temp_name,
							};
	 				}

	 			}
					if(message.msg){
						msj = message.msg;
					}
					
					if (message.code) {
						if (vm.$ml.get(message.code)) {
							msj  = vm.$ml.get(message.code);
						}
						if (!temp_device && message.deviceId) {
							let temp_name = vm.render_device(message.deviceId);
	 					temp_device = {
	 						deviceId : message.deviceId,
								name 	 : temp_name,
							};
						}
						if (temp_device) {
							msj 	   += ' : ' + temp_device.name;
							if (message.error){
								persistent  = true;
								position 	= 'down';
							}
							
						}
						
					}
					if (vm.setting_support && vm.setting_support.notifications && vm.setting_support.notifications.notifications_technical) {
						
	 				EventBus.$emit('notifications_modal',{
	 					type,
	 					message    : msj,
	 					position ,
	 					persistent,
	 				});
					}

			}
		}, // methods

		async mounted() {			
			if (this.$confidence) {
				this.$Format.update_list('confidence', this.$confidence);
			}
			
			EventBus.$on('is_alert_sound',  (action) => {
				this.is_sound = action;
				
			});

			EventBus.$on('render_categories', (action) => {
				if(action){
				}
			});
			EventBus.$on('render_access_rules', (action) => {
				if(action){
				}
			});				

			if (localStorage.getItem('alert_sound_status')) {
				this.is_sound = JSON.parse(localStorage.getItem('alert_sound_status'));
				
			}

			if (localStorage.getItem('modal_active')) {
		   		this.is_modal_alert = JSON.parse(localStorage.getItem('modal_active'))
			}

			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}

			let vm 				= this, 
				cont 			= 0, 
				list_sockets 	= [];
			let lists 				= 	[], 
				services_init 		=	false;

			if (this.connection.ws) {
			}			
			
			let ev = this;

			if (this.connection.socket) {
				let localhost_socket = this.$localsocket,
					port_socket_ 	 = this.$port_socket,
					space 			 = this.$namespace;
					
					const time_connect = setTimeout( () =>{
						this.connect_socket(localhost_socket, port_socket_, space,'motion', 'motion' );
						this.connect_socket(localhost_socket, port_socket_, space,'lpr', 'lpr' );
						this.connect_socket(localhost_socket, port_socket_, space,'data', 'data' );
						this.connect_socket(localhost_socket, port_socket_, space,'GUNS', 'guns');
						this.connect_socket(localhost_socket, port_socket_, space,'user', 'user');
						this.connect_socket(localhost_socket, port_socket_, space,'counter', 'counter');
						this.connect_socket(localhost_socket, port_socket_, space,'metadata', 'data');

						clearTimeout(time_connect);
					}, 3000);

				EventBus.$on('start_stream', (action, name_device) =>{
					let device 		= action;
					let name_dev 	= name_device ? name_device : action;
					this.list_devices_online.push(device);
					if (device && !this.socket[device]) {
						
						this.connect_socket(localhost_socket, port_socket_, space, device, name_dev);
					}else{
						// console.log("This device its streaming ", device, name_dev)
					}
				})

				EventBus.$on('close_stream', (action) =>{
					let device = action;

					let idx = this.list_devices_online.findIndex( x => (x ==  device))
					if (idx >= 0) {
						this.list_devices_online.splice(idx, 1);
					}
					if (this.list_devices_online.filter(x => x == device).length == 0) {

					if (device && this.socket[device]) {
						this.socket[device].emit("close_streaming",device);
						this.socket[device].disconnect();

						if (this.list_connections[device]) {
							delete this.list_connections[device];
							delete this.socket[device];
						}		
						if (this.socket['test_' + device]) {

						this.socket['test_' + device].emit("close_streaming",device);
						this.socket['test_' + device].disconnect();
							if (this.list_connections['test_' + device]) {
								delete this.list_connections['test_' + device];
								delete this.socket['test_' + device]
							}					
						}
					}
					}else{
					}
				})

				EventBus.$on('add_new_device',(action) => {
					let { deviceId , rtsp} = action;

					vm.check_streaming = false;
					vm.clearNewDeviceRtspTimer();
					if (rtsp !== '' ) {

						this.connect_socket(localhost_socket, port_socket_, space, rtsp, 'connection_rtsp', deviceId);	
					}
					if (deviceId == 'new_device') {

						vm.timer_res_rtsp = setTimeout( () =>{
							vm.handleNewDeviceRtspTestFailure(null, rtsp);
						}, 8000)
					}
				})
				

				EventBus.$on('start_constellation_j', (action) =>{
					let constellation 	= action;
					
					if (constellation) {
						vm.list_constellation.push({
									state 	: true,
									id 		: action.constellation.id,
									device 	: action.device.deviceId
								});
						vm.is_constellation = true;
						this.connect_socket(localhost_socket, port_socket_, space,action.device.deviceId, action.device.deviceId);

					}
				})
				
				EventBus.$on('start_installation_progress', (action) =>{
					let name = action.name;

					this.connect_socket(localhost_socket, port_socket_, space, 'installations', 'install-device');
				})

				EventBus.$on('logs_install_image', (action) => {
					if (action) {
						this.connect_socket(localhost_socket, port_socket_, space, 'installations','install-image');
					}
				});

				EventBus.$on('start_logs_container', (action) =>{
					let container = action && action.idContainer ? action.idContainer : null;
					if (container) {

						const api = this.$URL + '/api/v1/container/'+ container +'/logs'
						this.$axios.post(api).then(res => {
							this.connect_socket(localhost_socket, port_socket_, space,container);

						}).catch( er => {
							console.log("Error start logs ", er );
							let err = er && er.message ? er.message : er;
							EventBus.$emit('action_analytic', {
							action : 'Get info container : Error ' + err,
							color  : 'error'
						});
						} )
					}else{
						console.log(container, " No Valid to start logs")
					}



				})

				EventBus.$on('close_logs_container', (action) => {
					let container = action && action.idContainer ? action.idContainer : null;
					if (container && this.socket[container]) {
						this.socket[container].disconnect();
					}else{
						console.log(container, "No Valid to close logs")	
					}
				})
				
				

				EventBus.$on('req_status_analytics', (action) => {
					if (vm.status_analytics) {
						for (let idx_state in vm.status_analytics){
							EventBus.$emit('status_analytic' + vm.status_analytics[idx_state].deviceId, vm.status_analytics[idx_state]);	
					     	EventBus.$emit('status_analytic', vm.status_analytics[idx_state]);
						
						}
						
					}
				});
				
				EventBus.$on('start_counter', (action) => {
				});

				EventBus.$on('update_counter', (action) => {
					
				});

				EventBus.$on('close_counter', (action) => {
				});

				EventBus.$on('start_gps', (action) => {
					this.connect_socket(localhost_socket, port_socket_, space,'GPS', 'gps');
				}); 

				EventBus.$on('close_gps', (action) => {
					if (this.socket['gps']) {
    					console.log('close connection gps')

						this.socket['gps'].disconnect();
					}else{
						console.log('gps', "No Valid to close logs")	
					}
				}); 

				EventBus.$on('get_status_event', (action)=>{
					if (action) {
						EventBus.$emit('status_event' + action, vm.list_connections['data']);
					}
				});

				EventBus.$on("update_support", (action) => {
					if (action) {
						this.setting_support = action;
					}
				});

				EventBus.$on("liveness", (action) => {
					if (this.socket['liveness']){
						this.socket['liveness'].emit('liveness', action);
					}else{
						this.connect_socket(localhost_socket, port_socket_, space,'liveness', 'liveness');
					}
				});

				EventBus.$on("connection_sq", (action) => {
					if (action) {
						let connection = action.connection;

						if (this.socket[connection] && action.close){
							this.socket[connection].disconnect();

							if (this.list_connections && this.list_connections[connection]) {

								this.list_connections[connection].status =  this.$ml.get('disconnected');
					     		this.list_connections[connection].color  =  'secondary';

				     			EventBus.$emit('status_connections', this.list_connections);
								
				     			const timer = setTimeout(()=>{

									delete vm.list_connections[connection];
				     				EventBus.$emit('status_connections', vm.list_connections);
				     				clearTimeout(timer);
				     			},2000)
							}
						}else if (this.socket[connection]) {
							
							console.log("This connection already is connected ", connection);
							if (action.channel) {
								
								if (action.close_channel) {
									this.close_channel(connection, action.channel)
								}else{
									this.open_channel(connection, action.channel);
									console.log("open channel ", action.channel);
								}

							}
							

						}
						else{							
							this.connect_socket(localhost_socket, port_socket_, space, connection, connection);							
						}
					}
				});
				EventBus.$on("emit_to_channel", (action)=>{
					if (action) {
						const { workspace, channel, message } = action;
						if (this.socket && this.socket[workspace]) {
							this.socket[workspace].emit(channel, message);
						}
					}
				});				

			}

			this.getStatusTechnicals();
			EventBus.$on("getListTechnicals", (action)=>{								
				if (this.list_status_technicals) {
					for(let it in this.list_status_technicals){
						if (it && this.list_status_technicals[it]) {
	     					EventBus.$emit('events_technical_mapview', this.list_status_technicals[it]);	
	     				}	
					}
				}
			})
			EventBus.$on("setAlertMode", (action)=>{			
				this.render_type_alert({ type : "type", value: action});
			})			
		}, // mounted

		beforeDestroy(){
			if (this.socket) {
				Object.keys(this.socket).forEach(key => {
					if (this.socket[key] && typeof this.socket[key].disconnect === 'function') {
						this.socket[key].disconnect();
						this.socket[key] = null;
					}
				});
				this.socket = null;
			}

			if (this.close_interval) {
				clearInterval(this.close_interval);
				this.close_interval = null;
			}
			if (this.timer_stream) {
				clearInterval(this.timer_stream);
				this.timer_stream = null;
			}
			if (this.timer_res_rtsp) {
				clearTimeout(this.timer_res_rtsp);
				this.timer_res_rtsp = null;
			}

			if (this.list_connections) {
				this.list_connections = {};
			}
			if (this.list_devices_online) {
				this.list_devices_online = [];
			}

			// Limpiar arrays y objetos de datos
			this.list = [];
			this.all_list = [];
			this.all_list_hosts = [];
			this.data_alert = [];
			this.list_category = [];
			this.list_access_rules = [];
			this.list_constellation = [];
			this.list_devices = [];
			this.list_devices_online = [];
			this.list_channels = {};
			this.list_status_technicals = {};
			this.status_container_analytic = {};
			this.status_recording = {};
			this.status_analytics = {};
			this.settings = null;
			this.setting_support = null;
			this.item_alert = null;
			this.item_alertgun = null;

			// Limpiar variables de estado
			this.message = null;
			this.alert_type = null;
			this.alert_mode = null;
			this.is_sound = null;
			this.is_blacklist = null;
			this.is_modal_alert = null;
			this.is_constellation = null;
			this.check_streaming = null;
			this.type_alert = null;
			this.sound = null;

			// Limpiar EventBus listeners específicamente para evitar memory leaks
			const eventListeners = [
				'is_alert_sound',
				'render_categories',
				'render_access_rules',
				'start_stream',
				'close_stream',
				'add_new_device',
				'start_constellation_j',
				'start_installation_progress',
				'logs_install_image',
				'start_logs_container',
				'close_logs_container',
				'req_status_analytics',
				'start_counter',
				'update_counter',
				'close_counter',
				'start_gps',
				'close_gps',
				'get_status_event',
				'update_support',
				'liveness',
				'connection_sq',
				'emit_to_channel',
				'getListTechnicals',
				'setAlertMode'
			];

			eventListeners.forEach(eventName => {
				if (typeof EventBus.$off === 'function') {
					EventBus.$off(eventName);
				}
				if (this.$EventBus && typeof this.$EventBus.$off === 'function') {
					this.$EventBus.$off(eventName);
				}
			});

			// Limpiar todos los listeners restantes como fallback
			if (this.$EventBus && typeof this.$EventBus.$off === 'function') {
				this.$EventBus.$off();
			}
			if (typeof EventBus.$off === 'function') {
				EventBus.$off();
			}
		}, // beforeDestroy
		watch: {
			'$route.path'(newPath) {
				if (newPath === '/list_parking') {
					this.type_alert = 'snack';
				}
			}
		}
	};
</script>
